<template>
  <span v-if="hasDate">
    <span v-text="age" /><slot />
  </span>
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'VetsterPetAge',

  props: {
    pet: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    age() {
      if (!this.hasDate) {
        return null;
      }

      if (this.months < 12) {
        return `${this.months} ${this.$tc('units.months', this.months).toLowerCase()}`;
      }

      return `${this.years} ${this.$tc('units.years-old', this.years).toLowerCase()}`;
    },

    birthday() {
      if (!this.hasDate) {
        return null;
      }

      return DateTime.fromISO(this.pet.birthday_on, { zone: 'utc' });
    },

    hasDate() {
      return !!this.pet.birthday_on;
    },

    months() {
      return Math.max(1, this.durationDiff(this.birthday, 'months'));
    },

    years() {
      return this.durationDiff(this.birthday, 'years');
    },
  },

  methods: {
    durationDiff(dateTime, unit) {
      return Math.floor(Math.abs(dateTime.diffNow([unit]).toObject()[unit]));
    },
  },
};
</script>
